import type { ComputedRef } from 'vue'
import {
  usarCatalogoQuery,
  usarContextoCatalogo,
  type EstadoCatalogoQuery,
} from '@next/compartilhados/catalogos'
import {
  DESCRITOR_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO,
  type OpcaoGrupoDeLocaisDeTrabalho,
} from '../catalogo-grupo-de-locais-de-trabalho.tipos'
import { usarOperacoesCatalogoGrupoDeLocaisDeTrabalho } from './catalogo-grupo-de-locais-de-trabalho.injecao'

export const usarCatalogoGrupoDeLocaisDeTrabalho = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoGrupoDeLocaisDeTrabalho> => usarCatalogoQuery({
  catalogo: DESCRITOR_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO,
  contexto: usarContextoCatalogo(),
  consultar: usarOperacoesCatalogoGrupoDeLocaisDeTrabalho().listarOpcoes,
  ...(habilitado ? { habilitado } : {}),
})
